import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import Datatable from 'components/Common/dataTable';
import StatCard from 'components/Common/StatCard';

const { Title } = Typography;

interface ImportErrorDetail {
  rowIndex: number;
  reason: string;
  errors?: any[];
  rawData: Record<string, any>;
}

interface Props {
  errors: ImportErrorDetail[];
  created: number;
  skipped: number;
}

const ImportResultTable: React.FC<Props> = ({ errors, created, skipped }) => {
  const { t } = useTranslation();

  const columns = [
    {
      title: t('import_table_row'),
      dataIndex: 'rowIndex',
      key: 'rowIndex',
    },
    {
      title: t('import_table_reason'),
      key: 'reason',
      render: (_: any, record: ImportErrorDetail) => {
        if (record?.errors?.length) {
          return (
            <div>
              {record.errors.map((error: any, index: number) => (
                <div key={index}> <i className="fa fa-exclamation-circle pr-2" /> {t('importErrors.' + error?.message)}</div>
              ))}
            </div>
          );
        }
        return <div><i className="fa fa-exclamation-circle pr-2" /> {t('importErrors.' + record.reason)}</div>;
      },
    },
    {
      title: t('import_table_email'),
      key: 'email',
      render: (_: any, record: ImportErrorDetail) =>
        record.rawData?.["Email de l'élève"] ||
        record.rawData?.student?.user?.email ||
        "-",
    },
    {
      title: t('import_table_class_code'),
      key: 'classCode',
      render: (_: any, record: ImportErrorDetail) =>
        record.rawData?.["Code de la classe"] ||
        record.rawData?.student?.classCode ||
        "-",
    },
  ];

  return (
    <div style={{ marginTop: 24 }}>
      <Title level={4} style={{ marginBottom: 20 }}>
        {t('import_result_title')}
      </Title>

      <div className='row flex mb-4'>
        <div className='col-4 d-flex'>
          <StatCard
            color="green"
            icon="check"
            title={t("import_result_created", { count: created })}
            value={created}
          />
        </div>
        <div className='col-4 d-flex'>
          <StatCard
            color="yellow"
            icon="help"
            title={t("import_result_skipped", { count: skipped })}
            value={skipped}
          />
        </div>

        <div className='col-4 d-flex'>
          <StatCard
            color="red"
            icon="x"
            title={t("import_result_errors", { count: errors.length })}
            value={errors.length}
          />
        </div>

      </div>

      <Datatable dataSource={errors} columns={columns} pagination bordered />
    </div>
  );
};

export default ImportResultTable;
